import { render, staticRenderFns } from "./VendorValidationDetails.vue?vue&type=template&id=91449030"
import script from "./VendorValidationDetails.vue?vue&type=script&lang=js"
export * from "./VendorValidationDetails.vue?vue&type=script&lang=js"
import style0 from "./VendorValidationDetails.vue?vue&type=style&index=0&id=91449030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports